const src = import.meta.ROLLUP_FILE_URL_DzYsnjr1LtW1tBWqsYm2RQ;
export default {
  src,
  srcSet: src + " " + 1322 + "w",
  width: 1322,
  height: 892,
};